import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { compact, isEmpty } from 'lodash-es';
import { map, Observable } from 'rxjs';

import * as fromTitleRepSelectors from '../../../store/selectors/title-rep.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-share-contact-info',
  standalone: false,
  templateUrl: './share-contact-info.page.html'
})
export class ShareContactInfoPageComponent {
  private store = inject(Store);

  qrCodeData$: Observable<string>;

  constructor() {
    this.qrCodeData$ = this.store.pipe(select(fromTitleRepSelectors.selectContactInfo)).pipe(
      map((details) => {
        const qrCodeData = [
          'BEGIN:VCARD',
          'VERSION:3.0',
          'CATEGORIES:title rep',
          'CLASS:public',
          'KIND:individual',
          'LANG:en-US'
        ];
        if (!isEmpty(compact([details.lastName, details.firstName]))) {
          qrCodeData.push(`N:${compact([details.lastName, details.firstName]).join(';')}`);
          qrCodeData.push(`FN:${compact([details.firstName, details.lastName]).join(' ')}`);
        }
        if (!isEmpty(details.company)) {
          qrCodeData.push(`ORG:${details.company}`);
        }
        if (!isEmpty(details.email)) {
          qrCodeData.push(`EMAIL;TYPE=work:${details.email}`);
        }
        if (!isEmpty(details.phone)) {
          qrCodeData.push(`TEL;TYPE=${details.phoneType ?? 'office'}:${details.phone}`);
        }
        if (!isEmpty(details.photoUrl)) {
          qrCodeData.push(`PHOTO;TYPE=JPEG;VALUE=URI:${details.photoUrl}`);
        }
        qrCodeData.push('END:VCARD');

        return qrCodeData.join('\n');
      })
    );
  }
}
